<template>
  <div>
    <div v-if="tabs.length > 1" class="border-b dark:border-gray-800">
      <ul class="flex mx-auto max-w-screen-xl w-full md:w-11/12">
        <li v-for="(tab, index) in tabs" :key="index">
          <a
            href="#"
            v-scroll-to="{
              el: `#${tab.name.toLowerCase().replace(/ /g, '-')}`,
              offset: -250,
            }"
            :class="[{'border-primary-600 text-gray-900 dark:text-white': tab.isActive, 'text-gray-500 dark:text-gray-400': !tab.isActive}]"
            class="flex justify-between cursor-pointer border-b-2 border-transparent transition-colors p-4 px-8 -mb-px block outline-none"
            @click="selectTab(tab)"
          >
            <span class="font-bold">{{ tab.name }}</span>
          </a>
        </li>
      </ul>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'SectionsTabs',
  data () {
    return {
      tabs: []
    }
  },
  created () {
    this.tabs = this.$children
  },
  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = (tab.name === selectedTab.name)
      })
      this.$emit('changed', { tab: selectedTab.name })
    }
  }
}
</script>
